const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Link, Backdrop, CircularProgress } from '@mui/material';
import ReactHtmlParser from 'react-html-parser';

class ContestantDescription extends Component {
    constructor(props) {
        super(props);
        this.state = { read_more: '' };
    }

    componentDidMount = () => {
        this.setState({
            read_more: this.props.settings.color.votes_readmore_fontcolor,
        });
    }

    toggleHover = (value, name) => () => {
        this.setState({ read_more: value })
    }


    toggleleave = (value, name) => () => {
        this.setState({ read_more: value })
    }

    render() {
        const { t } = this.props;
        const { votes_cont_desc_font_size, votes_cont_dese_color, votes_readmore_fontcolor, votes_readmore_fontcolor_hover, votes_readmore_font_size } = this.props.settings.color;
        const { read_more } = this.props.settings.excerpt;
        const view = this.props.view;
        if (this.props.singlepost) {
            return (
                <div className="wpvc_contestant_description">
                    <Typography
                        variant="body2"
                        style={{ fontSize: votes_cont_desc_font_size + 'px', 'color': votes_cont_dese_color }}
                        component="div"
                        className="wpvc_content_description"
                    >
                        {ReactHtmlParser((view == 'single') ? this.props.singlepost.full_content : this.props.singlepost.post_excerpt)}
                    </Typography>

                    {this.props.settings.style.vote_readmore == 'off' && view != 'single' &&
                        <Link
                            className="wpvc_read_mores"
                            style={{ fontSize: votes_readmore_font_size + 'px', 'color': this.state.read_more }}
                            onMouseOver={this.toggleHover(votes_readmore_fontcolor_hover)}
                            onMouseLeave={this.toggleleave(votes_readmore_fontcolor)}
                            href={this.props.singlepost.wpvc_custom_link || this.props.singlepost.link}
                        >
                            {(read_more != '') ? read_more : t("fr_read_more")}
                        </Link>
                    }
                </div>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

export default connect()(withTranslation("translations")(ContestantDescription));
